import { OrderLinesList } from "@api/throughShipment/externalOrderApi";
import DashBoard from "@component/Common/DashBoard";
import PopupBackground from "@component/PopupBackground";
import { fetchExternalOrdersRevenue, externalOrderState } from "@redux/externalOrderSlice";

import React, { useEffect, useMemo } from "react";
import { Table, InputNumber } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useDispatch, useSelector } from "react-redux";

import * as Style from "./styles";

type Props = {
  orderLinesList: OrderLinesList[];
  onClose: () => void;
  setCheckOrderListPopup: (value: boolean) => void;
  setRequestQtyMap: (value: { [sku: string]: { sku: string; requestQty: number } }) => void;
  requestQtyMap: { [id: string]: { sku: string; requestQty: number } };
  externalOrderId: number;
};

const RequestQty = (props: Props) => {
  const { orderLinesList, onClose, setCheckOrderListPopup, setRequestQtyMap, requestQtyMap, externalOrderId } = props;

  const dispatch = useDispatch();
  const { externalOrdersRevenueResult } = useSelector(externalOrderState);
  const externalOrdersRevenueLists = useMemo(() => {
    return externalOrdersRevenueResult?.results ?? [];
  }, [externalOrdersRevenueResult?.results]);

  const requestQtyMapArr: { sku: string; requestQty: number }[] = Object.values(requestQtyMap);
  const totalRequestQty = requestQtyMapArr.reduce((acc, value) => acc + value.requestQty, 0);

  const dashBoardData = [
    {
      name: "總需求量(pcs)",
      value: totalRequestQty,
    },
  ];
  const columns: ColumnsType<any> = [
    {
      key: "sku",
      dataIndex: "sku",
      title: "SKU(品號)",
    },
    {
      key: "name",
      dataIndex: "name",
      title: "品名",
    },
    {
      key: "requestQty",
      dataIndex: "requestQty",
      title: "單品總需求量(pcs)",
      render: (value: any, data: any) => {
        const current = requestQtyMap[data.sku]?.requestQty ?? value;
        return (
          <InputNumber
            type="number"
            value={current}
            min={0}
            onChange={(e) => setRequestQtyMap({ ...requestQtyMap, [data.sku]: { sku: data.sku, requestQty: e } })}
          />
        );
      },
    },
  ];

  const onSubmit = () => {
    setCheckOrderListPopup(true);
    onClose();
  };

  useEffect(() => {
    dispatch(fetchExternalOrdersRevenue(externalOrderId));
  }, [dispatch, externalOrderId]);

  useEffect(() => {
    if (externalOrdersRevenueLists.length > 0) {
      const mapped = externalOrdersRevenueLists.reduce(
        (acc, data) => {
          acc[data.sku] = {
            sku: data.sku,
            requestQty: data.requestQty,
          };
          return acc;
        },
        {} as Record<string, { sku: string; requestQty: number }>,
      );
      setRequestQtyMap(mapped);
    }
  }, [externalOrdersRevenueLists, setRequestQtyMap]);

  const orderLinesListWithRequestQty = orderLinesList.map((item) => {
    const matchedSku = externalOrdersRevenueLists.find((data) => data.sku === item.sku);
    return {
      ...item,
      requestQty: matchedSku?.requestQty ?? 0,
    };
  });

  return (
    <PopupBackground close={onClose} fixed>
      <Style.Wrapper>
        <DashBoard dataset={dashBoardData} />
        <Style.Content>
          <Table
            columns={columns}
            dataSource={orderLinesListWithRequestQty}
            pagination={false}
            scroll={{ x: "max-content" }}
          />
        </Style.Content>
        <Style.CustomRow justify="end" align="middle">
          <Style.CustomButton
            marginRight="12px"
            onClick={() => {
              setRequestQtyMap({});
              onClose();
            }}
          >
            取消
          </Style.CustomButton>
          <Style.CustomButton type="primary" disabled={orderLinesList.length === 0} onClick={onSubmit}>
            下一步
          </Style.CustomButton>
        </Style.CustomRow>
      </Style.Wrapper>
    </PopupBackground>
  );
};

export default RequestQty;
